import LoginForm from "@/components/login-form";
import { LogoutButton } from "@/components/logout-button";
import Menulink from "@/components/menu-link";
import { useSidebar } from "@/context/sidebar-context";
import { useUser } from "@/context/user-context";
import classNames from "classnames";
import Icon from "../../icon";

type SidebarAccountProps = {
  redirectUrl?: string;
};

const menu: { label: string; href: string; icon: any }[] = [
  {
    label: "Min Profil",
    href: "/konto",
    icon: <Icon.Account className="fill-gray-500 h-[22px] w-[22px] mr-4" />,
  },
  {
    label: "Mitt flöde",
    href: "/mitt-efn",
    icon: <Icon.Pages className="fill-gray-500 h-[22px] w-[22px] mr-4" />,
  },
  {
    label: "Ämnen",
    href: "/konto/amnen",
    icon: <Icon.Topic className="fill-gray-500 h-[22px] w-[22px] mr-4" />,
  },
];

const SidebarAccount = (props: SidebarAccountProps) => {
  const { close } = useSidebar();
  const { user } = useUser();

  const getInitials = () => {
    if (!user) return null;
    const firstname = user?.info?.firstname?.[0] || "";
    const lastname = user?.info?.lastname?.[0] || "";

    if (!firstname) return null;
    return `${firstname}${lastname}`;
  };

  return (
    <div className="h-full pt-8 px-6 gap-6 relative flex flex-col">
      <div
        className={classNames(
          "flex justify-between items-center border-sand-600 pb-2",
          {
            "border-b-2 pb-6": user,
          }
        )}
      >
        {user ? (
          <div className="flex font-noto-sans items-center">
            <span className="rounded-full h-14 w-14 bg-black-300 flex items-center justify-center mr-3 uppercase text-white-500 font-semibold text-xl">
              {getInitials()}
            </span>
            <div>
              <h3 className="font-noto-sans text-2xl mb-0 pb-0 leading-snug">
                {user?.info?.firstname || user?.info?.lastname}
              </h3>
              <p className="text-gray-400 leading-none">{user?.info?.email}</p>
            </div>
          </div>
        ) : (
          <Icon.Logo className="fill-gray-300" />
        )}

        <button
          className="btn-icon h-10 w-10"
          onClick={close}
          aria-label="Stäng meny"
        >
          <Icon.Close className="fill-gray-300 h-4" />
        </button>
      </div>

      {user && (
        <ul className="font-semibold space-y-1">
          {menu.map((item, index) => (
            <li key={index} className="">
              <Menulink
                href={item.href}
                className="flex justify-between items-center py-4 px-3 hover:bg-sand-600"
                onClick={close}
              >
                <span className="flex items-center">
                  {item.icon}
                  {item.label}
                </span>
                <Icon.AngleRight className="h-3.5" />
              </Menulink>
            </li>
          ))}
        </ul>
      )}

      {!user && <LoginForm redirectUrl={props.redirectUrl || ""} />}

      {user && (
        <div className="px-6 mt-auto pb-6 items-end flex">
          <LogoutButton classname="ml-auto" />
        </div>
      )}
    </div>
  );
};

export default SidebarAccount;
